var _defs, _rect, _text, _text2, _text3, _text4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _rect2, _g9, _g10, _g11, _g12, _line, _g13, _g14, _g15, _g16, _g17, _path, _g18, _rect3, _g19, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 906,
    height: 626,
    viewBox: "0 0 906 626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17533",
    x: 0,
    y: 120,
    width: 476,
    height: 585,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3eb6fb",
    floodOpacity: 0.071
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17547",
    x: 185,
    y: 0,
    width: 630,
    height: 562,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Los_Angeles_CA_US"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "London_UK"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Melbourne_AU"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "New_York_NY_US"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Austin_TX_US"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg",
    x: 312,
    y: 121,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-2",
    x: 312,
    y: 174,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-3",
    x: 312,
    y: 227,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Alexis"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Jackson"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Dylan"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Sandra"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "John"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "First_Name"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Williams"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Bloom"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Turner"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Last_Name"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Brown"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Wilson"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-4",
    x: 312,
    y: 281,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-5",
    x: 312,
    y: 334,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-6",
    x: 312,
    y: 387,
    width: 73,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8b9ea5",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_46018",
    x: 594,
    y: 125,
    width: 412,
    height: 560,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16423",
    width: 15.179,
    height: 24.942,
    transform: "translate(88.128 34.729)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16425",
    width: 10.376,
    height: 17.003,
    transform: "translate(63.698 100.716)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16426",
    width: 7.726,
    height: 15.006,
    transform: "translate(55.003 125.488)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17546",
    x: 287,
    y: 435,
    width: 538,
    height: 311,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5026",
    cx: 30.946,
    cy: 30.946,
    r: 30.946,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47006",
    transform: "translate(-921 -1908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46530",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 861, 1818)",
    stroke: "rgba(62, 182, 251, 0.071)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(0px 0px 33px rgba(62, 182, 251, 0.071))"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17533-2",
    width: 278,
    height: 387,
    rx: 30,
    transform: "translate(99 219)",
    fill: "#212121"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_49_",
    transform: "translate(1178.154 2394)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "49%"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_61_",
    transform: "translate(1178.154 2353.5)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "61%"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_62_",
    transform: "translate(1178.154 2316.5)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "62%"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "Score",
    transform: "translate(994.154 2085)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Score"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45999",
    transform: "translate(999.911 2389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44299",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1246",
    y1: 0.395,
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5,
    y: -3.1,
    width: 80,
    height: 7,
    rx: 3.6,
    fill: "#17dbb5",
    stroke: "#17dbb5",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45998",
    transform: "translate(999.911 2349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44299-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1246-2",
    y1: 0.395,
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5,
    y: -3.5,
    width: 104,
    height: 7,
    rx: 3.6,
    fill: "#17dbc4",
    stroke: "#17dbc4",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45997",
    transform: "translate(999.911 2310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44985",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44297",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1289",
    y1: 0.395,
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.223
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5,
    y: -3.5,
    width: 108,
    height: 7,
    rx: 3.6,
    fill: "#19dada",
    stroke: "#19dada",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45992",
    transform: "translate(999.911 2114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44983",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44298"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1261",
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1264",
    x2: 140.666,
    fill: "none",
    stroke: "#0d5ada",
    strokeLinecap: "round",
    strokeWidth: 8
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45993",
    transform: "translate(999.911 2153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44984",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1283",
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1284",
    x2: 133.262,
    fill: "none",
    stroke: "#3e9cfb",
    strokeLinecap: "round",
    strokeWidth: 8
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45994",
    transform: "translate(999.911 2192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44984-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1283-2",
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1284-2",
    x2: 122.73,
    fill: "none",
    stroke: "#3db6fb",
    strokeLinecap: "round",
    strokeWidth: 8
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45995",
    transform: "translate(999.911 2231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44985-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44297-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1289-2",
    y1: 0.395,
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.223
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1291-2",
    x2: 118.455,
    y2: 0.395,
    fill: "none",
    stroke: "#31c6e2",
    strokeLinecap: "round",
    strokeWidth: 8
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45996",
    transform: "translate(999.911 2270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44985-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44297-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1289-3",
    y1: 0.395,
    x2: 148.069,
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.223
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1291-3",
    x2: 109.821,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#16cbda",
    strokeLinecap: "round",
    strokeWidth: 8
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46527",
    transform: "translate(-2265 643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3126, 1205)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17547-2",
    width: 432,
    height: 364,
    rx: 30,
    transform: "translate(304 99)",
    fill: "#212121"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46522",
    transform: "translate(3139 1048)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_CA_US-2",
    transform: "translate(554 368)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, CA, US")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_CA_US-3",
    transform: "translate(567 211)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, CA, US")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "London_UK-2",
    transform: "translate(554 421)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "London, UK")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "London_UK-3",
    transform: "translate(567 264)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "London, UK")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Melbourne_AU-2",
    transform: "translate(554 474)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Melbourne, AU")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Melbourne_AU-3",
    transform: "translate(567 317)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Melbourne, AU")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "New_York_NY_US-2",
    transform: "translate(554 524)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New York, NY, US")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "New_York_NY_US-3",
    transform: "translate(567 367)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New York, NY, US")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Austin_TX_US-2",
    transform: "translate(554 574)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Austin, TX, US")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Austin_TX_US-3",
    transform: "translate(567 417)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Austin, TX, US")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Location-2",
    transform: "translate(554 314)",
    fill: "#78849e",
    fontSize: 13,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Location"))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(3462 1346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-7",
    transform: "translate(336 141)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Check-2",
    transform: "translate(3462 1399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-8",
    transform: "translate(336 194)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Check-3",
    transform: "translate(3462 1452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-9",
    transform: "translate(336 247)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1292",
    x2: 366,
    transform: "translate(3462 1384)",
    fill: "none",
    stroke: "#d6dae2",
    strokeWidth: 1
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46518",
    transform: "translate(3074 1048)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Alexis-2",
    transform: "translate(436 368)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alexis")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Alexis-3",
    transform: "translate(384 211)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alexis")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Jackson-2",
    transform: "translate(436 421)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jackson")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Jackson-3",
    transform: "translate(384 264)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jackson")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Dylan-2",
    transform: "translate(436 474)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dylan")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dylan-3",
    transform: "translate(384 317)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dylan")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Sandra-2",
    transform: "translate(436 527)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sandra")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sandra-3",
    transform: "translate(384 370)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sandra")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "John-2",
    transform: "translate(436 580)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "John")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "John-3",
    transform: "translate(384 423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "John")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "First_Name-2",
    transform: "translate(436 314)",
    fill: "#78849e",
    fontSize: 13,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "First Name"))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46519",
    transform: "translate(3039 1048)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Williams-2",
    transform: "translate(554 368)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Williams")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 87, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Williams-3",
    transform: "translate(467 211)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Williams")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Bloom-2",
    transform: "translate(554 421)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bloom")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 87, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bloom-3",
    transform: "translate(467 264)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bloom")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Turner-2",
    transform: "translate(554 474)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Turner")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 87, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Turner-3",
    transform: "translate(467 317)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Turner")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Last_Name-2",
    transform: "translate(554 314)",
    fill: "#78849e",
    fontSize: 13,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last Name"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Brown-2",
    transform: "translate(554 527)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brown")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 87, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Brown-3",
    transform: "translate(467 370)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brown")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Wilson-2",
    transform: "translate(554 580)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wilson")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 87, 157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Wilson-3",
    transform: "translate(467 423)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wilson")))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Check-4",
    transform: "translate(3462 1506)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-10",
    transform: "translate(336 301)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Check-5",
    transform: "translate(3462 1559)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-11",
    transform: "translate(336 354)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Check-6",
    transform: "translate(3462 1612)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-12",
    transform: "translate(336 407)",
    fill: "none",
    stroke: "#2c72d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 22,
    rx: 4,
    fill: "none"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46529",
    transform: "translate(23 90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 838, 1758)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46018-2",
    d: "M30,0H184a30,30,0,0,1,30,30V332a30,30,0,0,1-30,30H30A30,30,0,0,1,0,332V30A30,30,0,0,1,30,0Z",
    transform: "translate(713 224)",
    fill: "#212121"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46525",
    transform: "translate(647 1575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45133",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45152",
    d: "M.849,35.64c32.628.489,69.619.114,102,.117a214.913,214.913,0,0,1-8.656,23.356c-26.021.5-56.412,1-82.8-.136A129.864,129.864,0,0,1,.849,35.64",
    transform: "translate(960 474)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45153",
    d: "M48.374,60.513c-12.762,0-25.258-.184-37.016-.688a.849.849,0,0,1-.7-.435A132.061,132.061,0,0,1,.042,35.9a.85.85,0,0,1,.123-.768.833.833,0,0,1,.7-.345c22.847.342,47.779.261,71.891.182,10.331-.033,20.1-.065,29.657-.065h.44a.85.85,0,0,1,.81,1.1,214.947,214.947,0,0,1-8.691,23.448.849.849,0,0,1-.758.5c-15.106.291-30.658.551-45.836.551M11.906,58.149c25.409,1.069,54.281.653,81.731.125a211.652,211.652,0,0,0,8.054-21.668c-9.328,0-18.862.033-28.933.065-23.7.078-48.19.158-70.725-.165a131.107,131.107,0,0,0,9.873,21.643",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    d: "M-491.3-1354.228a.851.851,0,0,1-.749-.484,98.989,98.989,0,0,1-6.926-19.04.852.852,0,0,1,.156-.722.851.851,0,0,1,.663-.327c24.58-.2,50-.4,74.525.193a.844.844,0,0,1,.7.4.85.85,0,0,1,.049.806c-1.374,2.948-2.95,7-4.476,10.92-.964,2.478-1.96,5.04-2.9,7.3a.847.847,0,0,1-.767.524l-.544.012a2.046,2.046,0,0,1-.861.192h-.035a2.322,2.322,0,0,1-.815-.156c-13.574.291-27.582.55-40.949.55C-480.07-1354.061-485.792-1354.11-491.3-1354.228Z",
    transform: "translate(1473.215 1919.045)",
    fill: "#0071ce",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45156",
    d: "M29.486,100.657c15.1.218,30.2.437,45.38.941-2.591,4.705-4.9,9.567-7.467,15.011-10.446.044-20.892.04-31.225-.571a79.128,79.128,0,0,1-6.688-15.381",
    transform: "translate(960 474)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45157",
    d: "M60.969,117.474c-8.406,0-16.67-.1-24.846-.59a.847.847,0,0,1-.7-.442,79.118,79.118,0,0,1-6.758-15.552.854.854,0,0,1,.142-.75.8.8,0,0,1,.687-.332c14.838.214,30.182.436,45.4.941a.849.849,0,0,1,.715,1.258c-2.484,4.511-4.651,9.047-7.442,14.964a.848.848,0,0,1-.765.486q-3.229.014-6.433.017m-24.274-2.257c9.879.568,19.911.586,30.164.545,2.45-5.189,4.431-9.325,6.6-13.361-14.352-.46-28.808-.676-42.83-.879a80.5,80.5,0,0,0,6.063,13.695",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45158",
    d: "M41.6,125.76c7.256-.136,14.516-.033,21.767.485-2.447,4.064-4.984,8.491-5.064,13.517-3.841.035-7.681.138-11.645.078A29.4,29.4,0,0,0,41.6,125.76",
    transform: "translate(960 474)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45159",
    d: "M49.223,140.707q-1.28,0-2.573-.018a.849.849,0,0,1-.834-.8A28.657,28.657,0,0,0,40.9,126.228a.848.848,0,0,1,.692-1.317c8.017-.149,15.163.01,21.843.487a.848.848,0,0,1,.667,1.284c-2.66,4.419-4.868,8.455-4.941,13.093a.849.849,0,0,1-.841.836c-1.124.01-2.247.026-3.372.042-1.87.027-3.784.054-5.722.054M47.448,139c2.532.024,5.038-.01,7.472-.045q1.29-.02,2.575-.035c.309-4.559,2.516-8.682,4.437-11.923-5.807-.373-11.985-.507-18.8-.414A29.985,29.985,0,0,1,47.448,139",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45160",
    d: "M52.44,27.042h-.018a.85.85,0,0,1-.832-.867c.173-8.395-.042-16.9-.639-25.266a.849.849,0,1,1,1.693-.12c.6,8.421.818,16.974.644,25.422a.85.85,0,0,1-.848.831",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45161",
    d: "M52.562,27.327a.852.852,0,0,1-.574-.223,6.728,6.728,0,0,1-1.552-2.619l-.133-.332a19.3,19.3,0,0,0-3.1-5.143.849.849,0,1,1,1.3-1.091,20.975,20.975,0,0,1,3.371,5.595l.137.344c.125.313.246.618.38.9a28.867,28.867,0,0,1,4.344-6.625.849.849,0,1,1,1.279,1.117A27.169,27.169,0,0,0,53.347,26.8a.854.854,0,0,1-.785.526",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45162",
    d: "M52.2,163.8h-.027a.848.848,0,0,1-.822-.874,139.323,139.323,0,0,0-.411-15.8.849.849,0,0,1,1.693-.14,141.088,141.088,0,0,1,.415,15.992.848.848,0,0,1-.848.822",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45163",
    d: "M52.1,163.916h0a.851.851,0,0,1-.723-.407L48.9,159.454a13.829,13.829,0,0,0-1.957-2.7.849.849,0,0,1,1.19-1.212,15.063,15.063,0,0,1,2.216,3.025l1.765,2.894A45.588,45.588,0,0,1,56.335,156,.85.85,0,0,1,57.6,157.14a43.859,43.859,0,0,0-4.774,6.372.849.849,0,0,1-.723.4",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45164",
    d: "M40.66,114.338a.283.283,0,0,1-.176-.061c-1.475-1.175-3.008-2.323-4.555-3.413a.283.283,0,1,1,.326-.463c1.557,1.1,3.1,2.252,4.581,3.432a.283.283,0,0,1-.176.5",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45165",
    d: "M46.748,114.756a.28.28,0,0,1-.194-.077,134.725,134.725,0,0,0-13.586-11.2.283.283,0,1,1,.33-.459,135.238,135.238,0,0,1,13.644,11.249.283.283,0,0,1-.194.489",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45166",
    d: "M51.87,114.187a.28.28,0,0,1-.2-.082,161.719,161.719,0,0,0-12.392-11.082.283.283,0,0,1,.355-.441A162.864,162.864,0,0,1,52.07,113.7a.283.283,0,0,1-.2.484",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45167",
    d: "M56.881,113.933a.283.283,0,0,1-.2-.086c-3.335-3.441-6.787-6.871-10.26-10.193a.283.283,0,1,1,.391-.409c3.478,3.327,6.935,6.762,10.275,10.208a.283.283,0,0,1-.2.48",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45168",
    d: "M63.159,113.912a.286.286,0,0,1-.206-.088c-3.258-3.441-6.669-6.83-10.141-10.074a.283.283,0,0,1,.387-.413c3.479,3.251,6.9,6.649,10.166,10.1a.283.283,0,0,1-.206.478",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45169",
    d: "M66.947,111.734a.28.28,0,0,1-.2-.082l-7.9-7.834a.283.283,0,1,1,.4-.4l7.9,7.834a.283.283,0,0,1-.2.484",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45170",
    d: "M68.869,107.373a.286.286,0,0,1-.2-.083c-1.13-1.14-2.315-2.25-3.522-3.3a.283.283,0,1,1,.371-.427c1.217,1.06,2.412,2.18,3.553,3.329a.283.283,0,0,1-.2.482",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45171",
    d: "M70.618,104.683a.279.279,0,0,1-.164-.053,5.034,5.034,0,0,1-1.022-.966.283.283,0,0,1,.444-.352,4.5,4.5,0,0,0,.906.858.283.283,0,0,1-.164.513",
    transform: "translate(960 474)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45122",
    transform: "translate(960 474)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45172",
    d: "M100.465,34.956a1.887,1.887,0,0,0-.922.138,2.2,2.2,0,0,0-2.977,2.144c-.008.032-.016.065-.027.115a19.411,19.411,0,0,1-1.076,2.833c-.805,2.03-1.463,4.111-2.191,6.168-1.26,3.662-3.243,6.812-5.115,11.189a1.9,1.9,0,0,0,3.091,1.7,1.99,1.99,0,0,0,2.774-.722,58.818,58.818,0,0,0,2.132-5.93,2.055,2.055,0,0,0,1.5-1.514c1.085-2.365,1.748-4.888,2.619-7.332.866-2.323,1.608-3.441,2.831-6.3a1.905,1.905,0,0,0-2.638-2.5",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45128",
    transform: "translate(960 474)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45126",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45174",
    d: "M74,102.153a1.987,1.987,0,0,0-2.889-1.175A3.148,3.148,0,0,0,70,102.447c-.48.9-.908,1.82-1.352,2.736-1.517,3.094-2.971,6.22-4.635,9.24a2.194,2.194,0,0,0,3.788,2.214c1.548-3.209,2.943-6.488,4.51-9.688q.705-1.485,1.357-2.993a2.3,2.3,0,0,0,.338-1.8",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45131",
    transform: "translate(960 474)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45129",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45175",
    d: "M62.692,127.273a2.062,2.062,0,0,0-3.071-1.509c-1.282.956-1.674,2.763-2.363,4.149-1.057,2.8-2.164,5.754-2.255,8.762a2.124,2.124,0,0,0,4.144.283,29.354,29.354,0,0,1,2.973-9.672,3.135,3.135,0,0,0,.572-2.013",
    fill: "#78849e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45132",
    transform: "translate(-2.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3802",
    transform: "translate(1030.826 689.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3804",
    d: "M-47.832-116.459h0a6.486,6.486,0,0,1-6.486-6.486v-2.82a6.486,6.486,0,0,1,6.486-6.486h0a6.486,6.486,0,0,1,6.486,6.486v2.82A6.486,6.486,0,0,1-47.832-116.459Z",
    transform: "translate(54.317 132.25)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3806",
    transform: "translate(1021.521 704.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3808",
    d: "M-129.594-114.379h14.01v-6.029a9.48,9.48,0,0,0-9.48-9.48h-22.1",
    transform: "translate(147.166 129.888)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3810",
    transform: "translate(984.081 689.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3812",
    d: "M-47.832-116.459h0a6.486,6.486,0,0,0,6.486-6.486v-2.82a6.486,6.486,0,0,0-6.486-6.486h0a6.486,6.486,0,0,0-6.486,6.486v2.82A6.486,6.486,0,0,0-47.832-116.459Z",
    transform: "translate(54.317 132.25)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3814",
    transform: "translate(974.775 704.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3816",
    d: "M-105.672-114.379H-120v-6.029a9.48,9.48,0,0,1,9.48-9.48h22.1",
    transform: "translate(120 129.888)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3818",
    transform: "translate(1004.069 677.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3820",
    d: "M-72.8-199.66h0a9.87,9.87,0,0,1-9.871-9.871v-7.331a9.87,9.87,0,0,1,9.871-9.871h0a9.87,9.87,0,0,1,9.871,9.871v7.331A9.87,9.87,0,0,1-72.8-199.66Z",
    transform: "translate(82.666 226.733)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3822",
    transform: "translate(1004.153 686.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3824",
    d: "M-144.353-18.193h-1.515a15.1,15.1,0,0,1-8.272-2.467,15.1,15.1,0,0,1-8.272,2.467h-1.515",
    transform: "translate(163.926 20.66)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3826",
    transform: "translate(989.104 704.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3828",
    d: "M-138.542-178.467h30.886v-9.348a14.85,14.85,0,0,0-14.85-14.851h-19.97a14.851,14.851,0,0,0-14.851,14.851v9.348h4.458",
    transform: "translate(157.328 202.666)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3830",
    transform: "translate(1003.954 704.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3832",
    d: "M-147.281,0l-9.985,24.2L-167.252,0Z",
    transform: "translate(167.252)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3834",
    transform: "translate(1013.939 705.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3836",
    d: "M0-34.05v-4.617",
    transform: "translate(0 38.667)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3838",
    transform: "translate(1003.297 650.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3840",
    d: "M-78.489-122.693l-4.712,3.44a1.536,1.536,0,0,1-2.365-1.718l1.815-5.545-4.742-3.429a1.535,1.535,0,0,1,.9-2.78h5.852l1.791-5.541a1.535,1.535,0,0,1,2.922,0l1.791,5.541h5.852a1.535,1.535,0,0,1,.9,2.78l-4.742,3.429,1.815,5.545a1.536,1.536,0,0,1-2.365,1.718Z",
    transform: "translate(89.131 139.329)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3842",
    transform: "translate(1000.725 729.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3844",
    d: "M0,0H0",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "briefcase_6_",
    transform: "translate(1627.453 1964.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46018-3",
    d: "M140,50.2V47.329a2.085,2.085,0,0,1,2.079-2.079h10.809a2.085,2.085,0,0,1,2.079,2.079V50.2",
    transform: "translate(-116.936)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46019",
    d: "M63.514,266v11.015a1.941,1.941,0,0,1-1.935,1.935H36.935A1.941,1.941,0,0,1,35,277.015V266.065",
    transform: "translate(-18.71 -206.509)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46020",
    d: "M27.967,137.12C21.142,136.73,15,134.778,15,131.266v-4.58a1.939,1.939,0,0,1,1.935-1.935H44.159a1.939,1.939,0,0,1,1.935,1.935v4.58c0,3.535-6.22,5.489-13.1,5.862",
    transform: "translate(0 -74.371)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46021",
    d: "M219,286.75h4.774v2.226a2.232,2.232,0,0,1-2.226,2.226h-.323A2.232,2.232,0,0,1,219,288.976Z",
    transform: "translate(-190.84 -225.92)",
    fill: "none",
    stroke: "#0071ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46516",
    transform: "translate(37 465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 824, 1393)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546-2",
    width: 360,
    height: 113,
    rx: 30,
    transform: "translate(406 534)",
    fill: "#212121"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46514",
    transform: "translate(1259.737 1952.554)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45997",
    d: "M.062,30.946A30.946,30.946,0,1,1,31.008,61.893,30.947,30.947,0,0,1,.062,30.946",
    transform: "translate(-0.062 0)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45998",
    d: "M14.234,68.07S9.369,58.232,16.416,52.8c4.3-3.315,5.684-7.137,4.855-10.457s.143-12.164,3.058-15.377S42.236,21.1,46.54,29.149s1.943,13.7,4.3,18.343,6.355,5.93,5.746,14.83-8.3,14.866-9.548,14.7-21.462-2.148-22.989-2.977-9.817-5.975-9.817-5.975",
    transform: "translate(-3.881 -7.261)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45999",
    d: "M29.418,34.559a12.134,12.134,0,0,1-.433-7.994,5.012,5.012,0,0,1,2.484-2.928,2.714,2.714,0,0,1,.907-.285s-1.2-2.261,3.283-4.258,11.658-.966,14.725,5.026-.435,13.83-1.568,15.013-17.1.465-19.4-4.574",
    transform: "translate(-8.719 -5.534)",
    fill: "#000102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46000",
    d: "M56.927,91.654H12.672s1.387-11.633,2.49-16.549a14.354,14.354,0,0,1,.413-1.544c1.131-3.23,13.412-4.2,14.542-5.813h9.363c1.131,1.615,13.412,2.583,14.543,5.813a16.2,16.2,0,0,1,.5,1.921c1.088,5.109,2.4,16.172,2.4,16.172",
    transform: "translate(-3.904 -20.64)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46001",
    d: "M47.677,64.856l-5.664,2.822-5.664-2.822a11.41,11.41,0,0,0,1.335-3.662,20.588,20.588,0,0,0,.452-4.943h7.754a20.824,20.824,0,0,0,.237,3.758,12.488,12.488,0,0,0,1.551,4.846",
    transform: "translate(-11.117 -17.138)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46002",
    d: "M46.711,60.01c-2.746,1.464-6.666,1.336-8.443,1.185a20.6,20.6,0,0,0,.452-4.943h7.754a20.825,20.825,0,0,0,.237,3.758",
    transform: "translate(-11.702 -17.138)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46003",
    d: "M31.2,43.573s-.909-3.595-3.169-2,0,6.847,3.185,6.819c0,0,.85-3.524-.016-4.817",
    transform: "translate(-8.304 -12.541)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46004",
    d: "M29.466,44.159a2.908,2.908,0,0,1,1.154.957,3.512,3.512,0,0,1,.784,1.27c.038.145-.166.209-.25.111-.238-.278-.418-.6-.636-.894a1.644,1.644,0,0,1-.656.407c-.2.048-.31-.2-.209-.348a1.492,1.492,0,0,1,.551-.419,7.585,7.585,0,0,1-.906-.855.148.148,0,0,1,.169-.227",
    transform: "translate(-8.959 -13.451)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46005",
    d: "M56.087,43.573s.909-3.595,3.169-2,0,6.847-3.185,6.819c0,0-.85-3.524.016-4.817",
    transform: "translate(-17.012 -12.541)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46006",
    d: "M58.842,44.159a2.913,2.913,0,0,0-1.154.957,3.512,3.512,0,0,0-.784,1.27c-.038.145.166.209.25.111.238-.278.418-.6.636-.894a1.644,1.644,0,0,0,.656.407c.2.048.311-.2.21-.348a1.5,1.5,0,0,0-.551-.419,7.586,7.586,0,0,0,.906-.855.147.147,0,0,0-.169-.227",
    transform: "translate(-17.378 -13.451)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46007",
    d: "M49.278,34.022c-1.881-9.022-8.8-8.389-8.8-8.389s-6.919-.633-8.8,8.389a17.293,17.293,0,0,0,.8,10.04c1.22,3,3.563,6.228,8,6.228s6.776-3.23,8-6.228a17.293,17.293,0,0,0,.8-10.04",
    transform: "translate(-9.574 -7.806)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46008",
    d: "M38.236,42.288s-.768.286-.652-1.074c.1-1.222.652-1.058.652-1.058s.534,0,.453,1.066-.453,1.066-.453,1.066",
    transform: "translate(-11.49 -12.231)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46009",
    d: "M49.508,42.288s-.768.286-.652-1.074c.1-1.222.652-1.058.652-1.058s.534,0,.453,1.066-.453,1.066-.453,1.066",
    transform: "translate(-14.924 -12.231)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46010",
    d: "M45.232,51.939a8.67,8.67,0,0,1-1.916.624c-.646.038-1.213-.286-1.824-.276a.1.1,0,0,0-.083.145c.705,1.094,3.362.755,3.979-.289a.14.14,0,0,0-.156-.2",
    transform: "translate(-12.654 -15.822)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46011",
    d: "M39.054,37.125a2.022,2.022,0,0,0-1.32-.3c-.411.006-1,.008-1.275.352a.074.074,0,0,0,.033.122,3.5,3.5,0,0,0,1.154-.047,12.078,12.078,0,0,0,1.314.1c.1-.013.2-.147.1-.23",
    transform: "translate(-11.145 -11.219)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46012",
    d: "M50.569,36.82a1.129,1.129,0,0,0-1.156-.46c-.419.037-1.053.156-1.273.553a.108.108,0,0,0,.065.158c.335.092.627-.109.955-.176a2.575,2.575,0,0,1,1.236.151.156.156,0,0,0,.174-.226",
    transform: "translate(-14.705 -11.074)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46013",
    d: "M43.43,45.885c-.344-.073-1.161-.063-1.293-.33a10.342,10.342,0,0,1,.6-1.918,7.813,7.813,0,0,0,.232-3.258.062.062,0,0,0-.119,0c-.212.906-.22,1.845-.413,2.758s-.527,1.791-.807,2.69a.171.171,0,0,0,.163.213,4.469,4.469,0,0,0,1.642.022.093.093,0,0,0,0-.178",
    transform: "translate(-12.722 -12.288)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46014",
    d: "M37.138,26.629a24.294,24.294,0,0,0,10.779,1.959s3.162,4.342,3.507,7.494a9.213,9.213,0,0,0-.546-8.591c-2.656-4.756-12.552-6.147-13.74-.862",
    transform: "translate(-11.357 -7.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46015",
    d: "M56.927,94.877H12.672s.1-.861.277-2.22q.043-.31.086-.662c.014-.1.021-.192.035-.3.029-.22.057-.455.092-.7.121-.9.256-1.907.391-2.952l.107-.7c.015-.114.029-.22.042-.334.043-.284.079-.562.121-.847.136-.925.277-1.864.42-2.767.05-.341.107-.676.164-1.01.035-.249.078-.484.113-.719.213-1.266.434-2.418.64-3.336,5.593,1.843,16.692,2.169,39.361.377.149.711.306,1.53.462,2.426.064.348.121.711.185,1.081.007.064.021.129.029.193.064.384.128.782.192,1.181.107.676.207,1.366.306,2.064.071.448.135.9.2,1.345.008.035.008.064.015.1.057.405.114.8.163,1.2.114.782.213,1.537.306,2.234.043.355.092.7.129,1.031.021.129.035.257.049.378.042.313.079.6.114.875l.256,2.071",
    transform: "translate(-3.904 -23.863)",
    fill: "#2f8dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46016",
    d: "M30.561,49.534a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5",
    transform: "translate(-9.354 -14.938)",
    fill: "#308dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46017",
    d: "M57,49.534a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5",
    transform: "translate(-17.41 -14.938)",
    fill: "#308dbd"
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "Alexis_Williams",
    transform: "translate(1339.556 1975)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alexis Williams"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "Cybersecurity_Engineering",
    transform: "translate(1339.556 2005)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cybersecurity Engineering"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentPool);
export default __webpack_public_path__ + "static/media/talentPool.63378e81e00caccc3dbcbd8e58dca978.svg";
export { ForwardRef as ReactComponent };